"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MilesDoubleCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MilesDoubleCircleLinear = function MilesDoubleCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M32.782 34.377A1 1 0 0031 35v2.5h-.5a1 1 0 100 2h.5V41a1 1 0 102 0v-3.14l1.218 1.528a1 1 0 001.564 0L37 37.859V41a1 1 0 102 0v-1.5h.5a1 1 0 100-2H39V35a1 1 0 00-1.782-.623L35 37.16l-2.218-2.783z",
    fill: "url(#MilesDoubleCircleLinear_svg__MilesDoubleCircleLinear_svg__paint0_linear_17373_95654)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.81 15.999c1.507-.632 3.52-.999 5.69-.999 2.17 0 4.183.367 5.69.999.751.315 1.424.716 1.925 1.212.504.5.885 1.154.885 1.934 0 .044-.001.087-.003.13.002.028.003.056.003.085v10.576a9 9 0 11-3.33 13.287c-1.436.508-3.24.798-5.17.798-2.17 0-4.183-.367-5.69-.999-.751-.315-1.424-.715-1.925-1.212-.504-.5-.885-1.154-.885-1.934V19.36c0-.029.001-.057.004-.085a2.432 2.432 0 01-.004-.13c0-.78.381-1.434.885-1.934.5-.496 1.174-.897 1.925-1.212zm-.516 2.632c-.256.253-.294.426-.294.514 0 .088.038.261.294.514.258.257.683.534 1.29.788 1.207.506 2.945.843 4.916.843 1.971 0 3.709-.337 4.917-.843.605-.254 1.03-.531 1.29-.788.255-.253.293-.426.293-.514 0-.088-.038-.261-.294-.514-.258-.256-.683-.534-1.29-.788C26.21 17.337 24.472 17 22.5 17c-1.971 0-3.709.337-4.917.843-.605.255-1.03.532-1.29.788zM27.82 32.572a9.056 9.056 0 011.18-1.28v-1.21a7.897 7.897 0 01-.81.392c-1.507.632-3.52 1-5.69 1-2.17 0-4.183-.368-5.69-1a7.897 7.897 0 01-.81-.393v1.375c0 .088.038.261.294.514.258.257.683.534 1.29.788 1.207.506 2.945.843 4.916.843 1.971 0 3.709-.337 4.917-.843a5.91 5.91 0 00.403-.186zm-1.796 4.762a8.96 8.96 0 01.434-2.175c-1.187.285-2.539.442-3.958.442-2.17 0-4.183-.367-5.69-.999a7.918 7.918 0 01-.81-.392v1.374c0 .088.038.261.294.514.258.257.683.534 1.29.788 1.207.506 2.945.843 4.916.843 1.306 0 2.51-.148 3.524-.395zM22.5 39.73c1.28 0 2.505-.127 3.603-.362.11.725.307 1.42.58 2.077-1.135.355-2.582.577-4.183.577-1.971 0-3.709-.337-4.917-.843-.605-.254-1.03-.531-1.29-.788-.255-.253-.293-.426-.293-.514v-1.538c.256.143.527.274.81.392 1.507.632 3.52 1 5.69 1zm5.69-17.438c.283-.118.554-.249.81-.392v1.3c0 .088-.038.261-.294.514-.258.257-.683.534-1.29.788-1.207.506-2.945.843-4.916.843-1.971 0-3.709-.337-4.917-.843-.605-.254-1.03-.531-1.29-.788-.255-.253-.293-.426-.293-.514v-1.301c.256.143.527.274.81.392 1.507.632 3.52 1 5.69 1 2.17 0 4.183-.368 5.69-1zm0 4.055a8.1 8.1 0 00.81-.393v1.375c0 .088-.038.261-.294.514-.258.257-.683.534-1.29.788-1.207.506-2.945.843-4.916.843-1.971 0-3.709-.337-4.917-.843-.605-.254-1.03-.531-1.29-.788-.255-.253-.293-.426-.293-.514v-1.375c.256.144.527.274.81.393 1.507.632 3.52 1 5.69 1 2.17 0 4.183-.368 5.69-1zM35 31a7 7 0 100 14 7 7 0 000-14z",
    fill: "url(#MilesDoubleCircleLinear_svg__MilesDoubleCircleLinear_svg__paint1_linear_17373_95654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8 16.062c-.928 0-1.728.31-2.292.946-.553.625-.812 1.492-.827 2.487a.6.6 0 00.6.609h.517a.6.6 0 00.6-.578c.025-.694.194-1.146.416-1.414.205-.248.508-.402.972-.402.428 0 .723.144.916.358.2.222.346.58.346 1.1 0 .413-.072.695-.238.968-.179.295-.489.619-1.044 1.066-1.19.911-1.973 1.59-2.457 2.304-.51.753-.66 1.5-.712 2.462a.6.6 0 00.6.632h5.095a.6.6 0 00.6-.6v-.476a.6.6 0 00-.6-.6h-3.778a2.29 2.29 0 01.275-.562c.204-.301.517-.612 1.076-1.056l.057-.045c1.448-1.153 1.487-1.184 1.905-1.617.662-.68.968-1.477.968-2.448 0-.898-.263-1.693-.805-2.267-.546-.578-1.313-.867-2.19-.867z",
    fill: "url(#MilesDoubleCircleLinear_svg__MilesDoubleCircleLinear_svg__paint2_linear_17373_95654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.771 18.772a.6.6 0 00-.848 0l-.294.294a.6.6 0 00.001.85l1.505 1.494-1.506 1.506a.6.6 0 000 .848l.294.294a.6.6 0 00.85-.001l1.494-1.505 1.506 1.506a.6.6 0 00.848 0l.294-.294a.6.6 0 000-.848L38.41 21.41l1.505-1.494a.6.6 0 00.001-.85l-.294-.294a.6.6 0 00-.847-.002l-1.507 1.497-1.496-1.495z",
    fill: "url(#MilesDoubleCircleLinear_svg__MilesDoubleCircleLinear_svg__paint3_linear_17373_95654)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30zm-2 0c0 15.464-12.536 28-28 28S2 45.464 2 30 14.536 2 30 2s28 12.536 28 28z",
    fill: "url(#MilesDoubleCircleLinear_svg__MilesDoubleCircleLinear_svg__paint4_linear_17373_95654)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MilesDoubleCircleLinear_svg__MilesDoubleCircleLinear_svg__paint0_linear_17373_95654",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MilesDoubleCircleLinear_svg__MilesDoubleCircleLinear_svg__paint1_linear_17373_95654",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MilesDoubleCircleLinear_svg__MilesDoubleCircleLinear_svg__paint2_linear_17373_95654",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MilesDoubleCircleLinear_svg__MilesDoubleCircleLinear_svg__paint3_linear_17373_95654",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MilesDoubleCircleLinear_svg__MilesDoubleCircleLinear_svg__paint4_linear_17373_95654",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.MilesDoubleCircleLinear = MilesDoubleCircleLinear;
var _default = MilesDoubleCircleLinear;
exports.default = _default;